import { TitleCasePipe } from '@angular/common';
import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'displayStatus',
  standalone: true,
})
export class DisplayStatusPipe implements PipeTransform {
  private readonly titleCasePipe = new TitleCasePipe();

  transform(value: string): string {
    if (value === 'NOT_AVAILABLE' || value === 'NOT_APPLICABLE') return 'N/A';

    return this.titleCasePipe.transform(value.replace(/_/g, ' '));
  }
}
